exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  font-family: Lato, Roboto, Noto, Helvetica, Tahoma, Arial, \"Microsoft YaHei New\", \"Microsoft Yahei\", \"Noto Sans CJK SC\", \"Noto Sans CJK\", \"\\5FAE\\8F6F\\96C5\\9ED1\", \"\\5B8B\\4F53\", SimSun, STXihei, \"\\534E\\6587\\7EC6\\9ED1\", \"PingFang SC\", sans-serif;\n}\n.serif {\n  font-family: Baskerville, \"Lucida Bright\", \"Times New Roman\", \"Times\";\n}\n.resetButton {\n  border: none;\n  background-color: none;\n}\n.search-page .weui-cell__ft:after {\n  border-width: 0 2px 2px 0;\n}\n.search-page .results {\n  background-color: white;\n}\n.search-page .results .weui-media-box__hd {\n  background-size: cover;\n}\n.search-page .findings {\n  background-color: #EAEEF3;\n}\n.search-page .findings .wrapper {\n  padding: 5px 10px 5px 10px;\n}\n.search-page .menu {\n  display: flex;\n  margin-top: 0;\n}\n.search-page .menu .weui-cell {\n  flex-grow: 2;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/search/Search.less
// module id = 1387
// module chunks = 0